var React = require('react');

function AccordionTrigger (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m20.5 0c-.3430955 0-.6212121.27811658-.6212121.62121193v19.25764447h-19.25757578c-.34309545 0-.62121212.2781166-.62121212.6212119 0 .3430954.27811667.621212.62121212.621212h19.25757578v19.2575078c0 .3430953.2781166.6212119.6212121.6212119s.6212121-.2781166.6212121-.6212119v-19.2575078h19.2575758c.3430954 0 .6212121-.2781166.6212121-.621212 0-.3430953-.2781167-.6212119-.6212121-.6212119h-19.2575758v-19.25764447c0-.34309535-.2781166-.62121193-.6212121-.62121193z","fillRule":"evenodd"}));
}

AccordionTrigger.defaultProps = {"viewBox":"0 0 41 41"};

module.exports = AccordionTrigger;

AccordionTrigger.default = AccordionTrigger;
